const DEFAULT_INACTIVITY_TIMEOUT = 180;

export {
    DEFAULT_INACTIVITY_TIMEOUT,
};
